// extracted by mini-css-extract-plugin
export var container = "_de-0";
export var containerTopRight = "_de-1";